module.exports = __webpack_public_path__ + "static/media/less-cramping-ON.0e422791.png";